// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__AMecg","tab":"ProcedureTabs_tab__3Q3qu"};